<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="#">
              ABOUT
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        Copyright &copy; 2019 Shorepower Technologies
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
